export default {
  items: [
    {
      name: "Cấu hình mẫu hợp đồng",
      url: "/admin/settings/electronic-contract-templates",
      nameRoute: "Admin-Settings-ElectronicContractTemplate-list",
      icon: "isax-document-text",
      meta: {
        allowAccess: ["*"],
        page: "admin",
        code: ["*"],
        collection: "Setting",
      },
    },
    {
      name: "Cấu hình mẫu văn bản",
      url: "/admin/settings/electronic-document-templates",
      nameRoute: "Admin-Settings-ElectronicDocumentTemplate-list",
      icon: "isax-document-copy",
      meta: {
        allowAccess: ["*"],
        page: "admin",
        code: ["*"],
        collection: "Setting",
      },
    },
  ],
};
